import { render, staticRenderFns } from "./MetaboliteDelete.vue?vue&type=template&id=0a87d5ca&"
import script from "./MetaboliteDelete.vue?vue&type=script&lang=js&"
export * from "./MetaboliteDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports